//
// Group analyser
//

GroupAnalyser = function (rules) {
  var _reverseSpin = false;
  var _rules = [];

  for (var i = 0; i < rules.length; ++i) {
    var newRule = {
      symbols: rules[i].symbols,
      replacement: rules[i].replacement,
      replacementChance: rules[i].replacementChance,
      replacementWeights: [],
      replacementWeightsSum: 0,
    };

    if (newRule.replacementChance !== undefined) {
      for (var j = 0; j < newRule.replacementChance.length; ++j) {
        var chance = newRule.replacementChance[j].chance;
        newRule.replacementWeights.push(chance);
        newRule.replacementWeightsSum += chance;
      }
    }

    _rules.push(newRule);
  }

  //Sort the rules by the number of symbols required so that larger blocks are replaced first
  _rules.sort(function (left, right) {
    return right.symbols.length - left.symbols.length;
  });

  this.analyse = function (symbols, postInjector) {
    var symbolsModified = false;
    var replacementMade = false;
    do {
      replacementMade = false;
      for (var i = 0; i < _rules.length; ++i) {
        var rule = _rules[i];
        // Check if this rule can be applied and where it should be applied to
        var replacementData = generateReplacementData(symbols, rule);
        if (replacementData.startIndex !== -1) {
          // Apply the rule
          replaceSymbols(symbols, replacementData, postInjector);
          symbolsModified = true;
          replacementMade = true;
          break;
        }
      }
      // If a rule was applied then we need to run all the rules again
      // This allows rules to stack against each other
    } while (replacementMade);

    return symbolsModified;
  };

  var generateReplacementData = function (symbols, rule) {
    var replacementData = {
      startIndex: symbols.indexOf(rule.symbols[0]),
      replacement: [],
      replaceLength: 0,
    };

    // Determine what the rule would place in to the symbols
    if (rule.replacement === undefined) {
      var index = getRandomWeighted(
        rule.replacementWeights,
        rule.replacementWeightsSum
      );
      replacementData.replacement =
        rule.replacementChance[index].replacement.slice();
    } else {
      replacementData.replacement = rule.replacement.slice();
    }

    if (replacementData.replacement.length === 0) {
      replacementData.startIndex = -1;
    }

    while (replacementData.startIndex >= 0) {
      var containsSymbols = true;
      // Check if it is possible to fit the rule symbols in to the remaining space
      if (replacementData.startIndex + rule.symbols.length <= symbols.length) {
        for (var i = 0; i < rule.symbols.length; ++i) {
          if (symbols[replacementData.startIndex + i] !== rule.symbols[i]) {
            containsSymbols = false;
            break;
          }
        }
      } else {
        replacementData.startIndex = -1;
        break;
      }

      // Check if applying the rule at this index would overwrite non-rule related data
      if (rule.symbols.length < replacementData.replacement.length) {
        if (
          replacementData.startIndex !== 0 &&
          replacementData.startIndex + rule.symbols.length !== symbols.length
        ) {
          containsSymbols = false;
        }
      }

      if (containsSymbols === true) {
        // Determine if the replacement can be done, if it is at the top or bottom of the landing symbols
        // then we can overflow in to the pre/post-injectors area.

        if (replacementData.startIndex === 0) {
          // At the top
          replacementData.replaceLength = Math.min(
            rule.symbols.length,
            replacementData.replacement.length
          );
          break;
        } else if (
          replacementData.startIndex + replacementData.replacement.length <=
          symbols.length
        ) {
          // In the middle
          replacementData.replaceLength = replacementData.replacement.length;
          break;
        } else if (
          replacementData.startIndex + replacementData.replacement.length >
          symbols.length
        ) {
          // At the bottom
          replacementData.replaceLength =
            symbols.length - replacementData.startIndex;
          break;
        }
      }

      replacementData.startIndex = symbols.indexOf(
        rule.symbols[0],
        replacementData.startIndex + 1
      );
    }

    return replacementData;
  };

  var replaceSymbols = function (symbols, replacementData, postInjector) {
    //postInjector.bounceSymbols = above landing symbols
    //postInjector.postSymbols = below landing symbols

    // If the replacement occurs at the top or the bottom then we need to notify the postInjector
    // so that it can add any additional symbols required to complete the groups
    // Note: The bounce symbols will be carried over to the preInjector if necessary.

    if (replacementData.startIndex === 0) {
      //At the top
      for (var i = replacementData.replaceLength - 1; i >= 0; --i) {
        symbols[i] = replacementData.replacement.pop();
      }

      if (!_reverseSpin) {
        postInjector.bounceSymbols = replacementData.replacement;
        postInjector.bounceSymbols.reverse();
      } else {
        postInjector.postSymbols = replacementData.replacement;
        postInjector.postSymbols.reverse();
      }
    } else if (
      replacementData.startIndex + replacementData.replacement.length >
      symbols.length
    ) {
      //At the bottom
      for (var i = 0; i < replacementData.replaceLength; ++i) {
        symbols[replacementData.startIndex + i] =
          replacementData.replacement.shift();
      }

      if (!_reverseSpin) {
        postInjector.postSymbols = replacementData.replacement;
        postInjector.postSymbols.reverse();
      } else {
        postInjector.bounceSymbols = replacementData.replacement;
      }
    } else {
      // Within the landing symbols
      for (var i = 0; i < replacementData.replaceLength; ++i) {
        symbols[replacementData.startIndex + i] =
          replacementData.replacement.shift();
      }
    }
  };

  Object.defineProperty(this, "isReverseSpin", {
    get: function () {
      return _reverseSpin;
    },
    set: function (reversed) {
      _reverseSpin = reversed;
    },
  });
};
